import React, { Fragment, useRef, useState } from 'react';
import './Categories.scss';
import { grid_data } from '../../Constants';
import { animated, useSpring } from 'react-spring';
import VideoModal from '../../components/video_modal/VideoModal';

export default function Categories() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [videoId, setVideoId] = useState('');
    const [videoTitle, setVideoTitle] = useState('');
    const [xAxisValue, setXAxisValue] = useState(0);
    const [yAxisValue, setYAxisValue] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);
    const categoryTabsRef = useRef<HTMLDivElement>(null);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };
    const clamp = (value: number, clampAt: number = 40) => {
        if (value > 0) {
            return value > clampAt ? clampAt : value;
        } else {
            return value < -clampAt ? -clampAt : value;
        }
    };

    const [springStyle, setSpring] = useSpring(() => ({
        transform: "perspective(900px) rotateY(0deg)"
    }));

    const handleWheel = (event: React.WheelEvent<HTMLDivElement>) => {
        let delta = 0;
        const containerElement: any = containerRef.current;
        if (xAxisValue !== event.deltaX) {
            setXAxisValue(event.deltaX)
            delta = event.deltaX
        } else if (yAxisValue !== event.deltaY && event.deltaX === -0) {
            setYAxisValue(event.deltaY)
            delta = event.deltaY
            containerElement.scrollLeft += delta * window.innerWidth / 10;
            containerElement.scrollX += (-delta) * window.innerWidth / 10;
        }

        setSpring({
            transform: `perspective(900px) rotateY(${clamp(delta)}deg)`
        });
    }

    const handleCategoryClick = (category: string) => {
        setActiveCategory(category);

        const tabElement = categoryTabsRef.current?.querySelector(`[data-category="${category}"]`);
        if (tabElement) {
            tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
        }
    };
    const categories = [...new Set(grid_data.map(item => item.category))];
    const [activeCategory, setActiveCategory] = useState(categories[0]);
    const filteredData = grid_data.filter(item => item.category === activeCategory);

    return (
        <Fragment>
            <div className='categories-main-container'>
                <div className="categories-tabs" ref={categoryTabsRef}>
                    {categories.map((category, index) => (
                        <div
                            key={index}
                            style={{ paddingLeft: index === 0 ? 0 : "3em" }}
                            className={`category-tab ${category === activeCategory ? 'active' : ''}`}
                            onClick={() => { handleCategoryClick(category) }}
                        >
                            {category}
                        </div>
                    ))}
                </div>
                <div
                    ref={containerRef}
                    style={{ justifyContent: filteredData.length === 1 ? "center" : "" }}
                    className="categories-container"
                    onWheel={handleWheel}
                >
                    {filteredData.map((item, index) => (
                        <animated.div key={index} className="categories-card" style={{ ...springStyle }} onClick={() => {
                            setVideoId(item.videoId)
                            setVideoTitle(item.title)
                            openModal();
                        }}>
                            <div className='categories-hidden-text'>
                                <div className='brand'>{item.brandName}</div>
                                <div className='desc'>{item.title}</div>
                                <div className='border-btm' />
                            </div>
                            <img className="categories-content-img" src={`/${item.image}`} alt={item.image} />
                        </animated.div>
                    ))}
                </div>
                <VideoModal isOpen={modalIsOpen} onClose={closeModal} videoId={videoId} videoTitle={videoTitle} />
            </div>
        </Fragment>
    );
}
